const defaults = {
  APP_NAME: 'admin',
  DIST: 'dist/admin',
  LOCAL_STORAGE_NAME: 'admin_access_token',
  LOCAL_STORAGE_USER_NAME: 'admin_user',
  LOGIN_PATH: '/admin/login',
  ERROR_LOGGING: true,
  ADMIN_HOST: 'http://localhost:7070',
  FEATURE_BETAS_ENABLED: true,
};

const staging = {
  ADMIN_HOST: 'https://staging.lumi.com.au',
};

const production = {
  ADMIN_HOST: 'https://www.lumi.com.au',
};

const admin_config = {
  staging,
  production,
};

export default function (environment, devVersion) {
  return {
    ...defaults,
    ...(admin_config[environment] || {}),
    ...(devVersion
      ? { ADMIN_HOST: `https://${devVersion}.lumi-tech.dev` }
      : {}),
  };
}
